module.exports = global["PIXI"] = require("-!./pixi.js");


//////////////////
// WEBPACK FOOTER
// ./~/phaser-ce/build/custom/pixi.js
// module id = 88
// module chunks = 1